import { useEffect } from 'react';
import { useAsyncError } from 'react-router';

import { logger } from '~/logger';

interface ErrorElementProps {
  message: string;
  context?: Record<string, any>;
  children?: React.ReactNode;
}

/**
 * エラーをログに記録し、オプションでUIを表示するコンポーネント
 * <Await>のerrorElementで使用する
 *
 * @see https://react-router-docs-ja.techtalk.jp/api/hooks/useAsyncError#%E6%A6%82%E8%A6%81
 */
export function AwaitErrorElement({ message, context = {}, children = null }: ErrorElementProps) {
  const error = useAsyncError();

  useEffect(() => {
    if (error) {
      logger.error({ error, ...context }, message);
    }
  }, [error, message, context]);

  return children;
}
